import styled from 'styled-components';

const SolutionsMenuContainer = styled.div`
  display: flex;
  padding: 0 !important;

  .MuiMenuItem-root {
    &:hover {
      background: none;
    }
  }

  .type-col {
    background: #f5f5f5;
    height: 100%;
    padding: 10px;
    position: absolute;
    width: 315px;

    .type-btns {
      height: max-content;
      position: relative;
    }

    .type-btns-bg-triangle {
      background-color: white;
      border-radius: 0 0 0 0.25em;
      border: 7px solid #f5f5f5;
      clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
      display: block;
      height: 35px;
      position: absolute;
      right: -17px;
      top: 49px;
      transform: rotate(-135deg);
      width: 35px;
    }

    .type-btns-bg {
      background: white;
      display: block;
      height: calc(50% - 5px);
      position: absolute;
      width: 100%;
      z-index: 0;

      &.residential.clicked {
        animation: move-dowm linear 0.2s;
        transform-origin: 50% 50%;
        -webkit-animation: move-down linear 0.2s;
        transform: translate(0, calc(100% + 10px));

        @keyframes move-down {
          0% {
            transform: translate(0, 0%);
          }
          24% {
            transform: translate(0, 24%);
          }
          50% {
            transform: translate(0, 50%);
          }
          74% {
            transform: translate(0, 74%);
          }
          100% {
            transform: translate(0, 100%);
          }
        }
      }

      &.commercial.clicked {
        animation: move-up linear 0.2s;
        transform-origin: 50% 50%;
        -webkit-animation: move-up linear 0.2s;
        transform: translate(0, 0%);

        @keyframes move-up {
          0% {
            transform: translate(0, 100%);
          }
          24% {
            transform: translate(0, 74%);
          }
          50% {
            transform: translate(0, 50%);
          }
          74% {
            transform: translate(0, 24%);
          }
          100% {
            transform: translate(0, 0%);
          }
        }
      }
    }

    .type-box {
      margin: 0;
      padding: 20px;
      position: relative;
      z-index: 999999;

      h6 {
        margin-top: 0 !important;
      }

      &.commercial {
        margin-bottom: 15px;
      }

      &.residential {
        margin-top: 15px;
      }

      &:hover {
        cursor: pointer;
      }

      &.hide {
        &:hover {
          background: rgba(123, 170, 245, 0.2);
        }
      }

      &.inactive {
        &:hover {
          background: var(--titan-blue-hover) !important;
        }
      }
    }

    .type-footer {
      bottom: 25px;
      left: 23px;
      position: absolute;
      width: 265px;

      a {
        margin: 0;
        width: 265px;
        &.header-menu-cta {
          text-transform: none !important;
        }
      }
    }
  }

  .item-col {
    width: 385px;
    padding: 0 40px;
  }

  .show {
    display: block;
  }

  .hide {
    display: none;Z
  }

  .nav-icon {
    width: 28px;
    margin-right: 15px;

    img {
      image-rendering: unset;
    }
  }

  .nav-copy {
    white-space: pre-wrap;
    width: calc(100% - 48px);
  }

  li {
    align-items: flex-start;
    padding: 10px;
    margin: 0 0 10px -12.5px;

    a {
      display: flex;
      width: 100%;
      align-items: center;
    }
  }

  h6 {
    margin: 7px 0 10px 0;
    font-weight: 600;
  }

  .solutions-items-container {
    display: flex;
    height: 88%;
    margin-bottom: 40px;
    position: relative;

    .left {
      width: 410px;

      li a {
        align-items: flex-start;
      }
    }

    .right {
      li {
        align-items: center;
        h6 {
          margin: 0;
        }
      }
    }
  }

  .hr {
    background: var(--grey-3);
    bottom: 50%;
    height: 85%;
    left: 50%;
    margin: auto;
    position: absolute;
    right: 50%;
    top: 50%;
    width: 1px;
  }

  p {
    font-size: var(--font-size-p-sm);
    margin: 0;
  }

  .solutions-items-col {
    position: relative;
    padding: 30px 0;
    margin-left: 325px;

    h6 {
      font-weight: 500;
    }
  }

  .group-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px !important;
  }

  .solutions-items-footer {
    bottom: 25px;
    left: 30px;
    position: absolute;
    width: calc(100% - 70px);
  }

  h6.group-title {
    font-weight: 600;
  }

  .group-title {
    color: var(--titan-blue-3);
  }
`;

export { SolutionsMenuContainer };
